import { render, staticRenderFns } from "./FrameworkControlObjective.vue?vue&type=template&id=6d880363&scoped=true&"
import script from "./FrameworkControlObjective.vue?vue&type=script&lang=js&"
export * from "./FrameworkControlObjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d880363",
  null
  
)

export default component.exports